<template>
<div class="main mt15 p34">
	<div class="my-title">{{info.productName}}</div>
    <div class="recognize-table mt10">
		<p style="font-size:14px"><b>批量加人</b></p>
        <Table border highlight-row :columns="columns" :data="addList" class="mt10">
			<template slot-scope="{ row, index }" slot="isAerial">
				{{row.isAerial==1?'高空':'非高空'}}
			</template>
			<template slot-scope="{ row, index }" slot="handle" v-if="!isReset">
				<!-- <a v-if="channel=='QZG'&&row.status==0" @click="openEdit(row)">编辑</a> -->
				<a @click="del1(index)">删除</a>
			</template>
		</Table>
    </div>
	<div class="mt10">
		<Button type="info" @click="add" v-if="!isReset">添加工种</Button>
		<!-- <Button type="success" @click="sub" :disabled="!canSub">提交信息</Button> -->
	</div>
	<template v-if="info.insuredPeriod==12">
		<div class="recognize-table mt10">
			<p style="font-size:14px"><b>批量替换</b>-被替换员工</p>
			<Table border highlight-row :columns="columnsList" :data="replaceList" class="mt10" max-height="500">
				<template slot-scope="{ row, index }" slot="isAerial">
					{{row.isAerial?'高空':'非高空'}}
				</template>
				<template slot-scope="{ row, index }" slot="insurantCertificateNumber">
					{{hideIdCard(row.insurantCertificateNumber)}}
				</template>
				<template slot-scope="{ row, index }" slot="handle" v-if="!isReset">
					<a @click="del2(index)">删除</a>
				</template>
			</Table>
		</div>
		<div class="mt10">
			<Button type="info" @click="openRelace" v-if="!isReset">添加被替换员工</Button>
		</div>
	</template>
	<div class="fixed-bottom">
			<UploadFile	
				style="display:inline-block"
				url="/pc/employerLiability/importBatchCorrect"
				:show-upload-list="false"
				:data="{policyId:id}"
				btn-text="上传批量批单数据"
				@on-success="uploadSuccessList" 
				 />
			根据已选批单生成模板，点击<a @click="download">下载</a>
			工种编号请通过<a href="/static/pdf/haierProduct/guoshou/5-职业分类表.pdf" target="_blank">职业类别表</a>查看

	</div>
	<Modal
		v-model="addShow"
		title="添加工种信息"
        width="400px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
			<FormItem label="人数" prop="count">
		        <Input v-model="addForm.count" ></Input>
		    </FormItem>
			<FormItem label="是否高空" prop="isAerial">
				<Select v-model="addForm.isAerial" @on-change="val=>aerialChange(val)" transfer>
					<Option value="1" v-if="isAerial">高空</Option>
					<Option value="0" v-if="isNoAerial">非高空</Option>
				</Select>
		    </FormItem>
			<template v-if="addForm.isAerial">
				<FormItem label="工种" prop="workTypeName">
					<SelectJob :value="addForm.workTypeName" productCode="GSCGZZRX" @change="val=>jobChange(val,'addForm')"/>
				</FormItem>
				<FormItem label="选择方案" prop="insurancePlanName" v-if="addForm.workTypeName" key="caseListAll">
					<Select v-model="addForm.insurancePlanName" placeholder="请选择保障方案" transfer>
						<Option :value="item.planName" v-for="(item, index) in caseListAll" :key="index">{{item.planName}}</Option>
					</Select>
				</FormItem>
			</template>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addShow=false">取消</Button>
			<Button type="primary" @click="confirmAdd" >确定</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="选择被替换人员  （同时按下Ctrl+F键，针对姓名检索）"
        width="900px"
		:closable="false"
        :mask-closable="false">
		 <Table border highlight-row :columns="columnsEdit" ref="selection" :data="orderData" @on-selection-change="onSelectionChange" max-height="500">
			<template slot-scope="{ row, index }" slot="isAerial">
				{{row.isAerial?'高空':'非高空'}}
			</template>
			<template slot-scope="{ row, index }" slot="insurantAmount">
				<span :style="{color:row.fiveRisk?'red':'#333'}">{{row.insurantAmount}}{{row.insurantAmount=='-'?'':'元'}}</span>
			</template>
			<template slot-scope="{ row, index }" slot="insurantCertificateNumber">
				{{hideIdCard(row.insurantCertificateNumber)}}
			</template>
			<template slot-scope="{ row, index }" slot="remarks">
				<span :style="{color:row.status==0?'#333':'red'}">{{row.remarks}}</span>
			</template>
		</Table>
		<template slot="footer">
			<Button type="text" @click="chancel">取消</Button>
			<Button type="primary" @click="confirmEdit">确定</Button>
		</template>
	</Modal>
	
	<Modal
		v-model="replaceShow"
		width="600px"
		title="确认批量操作信息"
		:fullscreen="true"
		:closable="false"
        :mask-closable="false">
		<Table border highlight-row :columns="columnsConfirm" ref="selection" :data="orderDataConfirm">
			<template slot-scope="{ row, index }" slot="checkMsg">
				<span style="color:red" v-if="!row.pass">
					{{row.checkMsg}}
				</span>
				<span style="color:green" v-else>
					校验通过
				</span>
			</template>
			<template slot-scope="{ row, index }" slot="isAerial">
				{{row.isAerial?'高空':'非高空'}}
			</template>
			<template slot-scope="{ row, index }" slot="insurantAmount">
				<span :style="{color:row.fiveRisk?'red':'#333'}">{{row.insurantAmount||0}}{{row.insurantAmount=='-'?'':'元'}}</span>
			</template>
			<template slot-scope="{ row, index }" slot="insurantCertificateNumber">
				{{hideIdCard(row.insurantCertificateNumber)}}
			</template>
			<template slot-scope="{ row, index }" slot="remarks">
				<span :style="{color:row.status==0?'#333':'red'}">{{row.remarks}}</span>
			</template>
		</Table>
		<template slot="footer">
			<Button type="text" @click="replaceShow=false;orderDataConfirm=[]">取消</Button>
			<Button type="primary" @click="sub" :disabled="canTrue">提交信息</Button>
		</template>
	</Modal>
	<Modal
		v-model="confirmShow"
		title="人员信息变更"
        width="400px"
        :mask-closable="false">
		<Form :label-width="130">
			<FormItem label="姓名变化员工数：" v-if="confirmForm.nameCount">
		        {{confirmForm.nameCount}}人
		    </FormItem>
			<FormItem label="替换员工数：" v-if="confirmForm.changeCount">
		        {{confirmForm.changeCount}}人
		    </FormItem>
			<FormItem label="退出员工数：" v-if="confirmForm.quitCount">
		        {{confirmForm.quitCount}}人，合计退回 {{confirmForm.refAmount}}元
		    </FormItem>
			<FormItem label="新增人员：" v-if="confirmForm.addCount">
		        {{confirmForm.addCount}}人，合计应缴纳 {{confirmForm.amount}}元
		    </FormItem>
			<FormItem :label-width="20">
				本次编辑人员，{{confirmForm.finalAmount>=0?'合计需缴纳':'合计需退回'}}
		        {{Math.abs(confirmForm.finalAmount)}}元
		    </FormItem>
			<FormItem label="上传批改单：" v-if="confirmForm.finalAmount>=0">
				点击下载批改单，盖章后上传<a @click="downloadPd">下载</a>
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					type="select" 
					btn-text="上传批改单"></UploadFileImg>
                <div v-if="correctUrlList.length>0">
                    <p v-for="(item,index) in correctUrlList" :key="index" >
                        批改单{{index+1}}&nbsp;&nbsp;&nbsp;<a :href="item" target="_blank" class="ml10" :key="index">查看</a>&nbsp;<a style="color:#ed4014" @click="del(index)">删除</a>
                    </p>
                </div>
				<!-- <a :href="correctUrl" v-if="correctUrl" target="_blank" class="ml10">查看</a> -->
		    </FormItem>
		</Form>
		<template slot="footer">
			<span v-if="confirmForm.finalAmount<0" class="edit-warning">本产品不支持退费，此次修改无效</span>
			<Button type="text" @click="confirmShow=false" v-if="confirmForm.finalAmount<0">关闭</Button>
			<Button type="text" @click="confirmShow=false;confirmLoading=false;" v-if="confirmForm.finalAmount>=0">取消</Button>
			<Button type="primary" @click="confirmSub" :disabled="correctUrlList.length==0" v-if="confirmForm.finalAmount>=0" :loading="confirmLoading">确定</Button>
		</template>
	</Modal>
	<TrackNotice />
</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
import SelectJob from '@/components/common/SelectJob'
import UploadFileImg from '@/components/common/UploadFileImg'
import { caseList } from '../../../scheme/components/common/dictionary'
import axios from 'axios'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	mixins:[ track ],
	components:{ SelectJob,UploadFileImg,UploadFile,TrackNotice },
	data () {
		return {
            correctUrlList:[],
			info:{},
			originalList:[],// 原始数据
			id:this.$route.params.id,
			addList:[],
			columns:[
                {type:'index',width:70,title:'序号',align: 'center',fixed:'left'},
                {title: '是否高空',slot: 'isAerial',width:100},
                {title: '选择计划',key: 'insurancePlanName',width:460},
				{title: '职业/工种',key: 'workTypeName'},
                {title: '人数',key: 'count',width:80},
				{title: '操作',slot: "handle",width:100,fixed:'right'}
			],
			columnsEdit:[
                {type:'selection',width:60,align: 'center',fixed:'left'},
                {title: '姓名',key: 'insurantName',width:80},
                {title: '证件号码',slot: "insurantCertificateNumber",width:170},
                {title: '是否高空',slot: 'isAerial',width:100},
				{title: '工种',key: 'jobTypeName',width:150},
                {title: '方案',key: 'insuranceSchemeName',width:'280'},
			],
			columnsList:[
                {title: '姓名',key: 'insurantName',width:100,fixed:'left'},
                {title: '证件号码',slot: "insurantCertificateNumber",width:190},
                {title: '是否高空',slot: 'isAerial',width:100},
				{title: '工种',key: 'jobTypeName',width:150},
                {title: '方案',key: 'insuranceSchemeName'},
				{title: '操作',slot: "handle",width:100,fixed:'right'}
			],
			columnsConfirm:[
				// {type:'index',width:70,title:'序号',align: 'center',fixed:'left'},
				{title: '校验结果',slot: "checkMsg",width:150,fixed:'left'},
				{title: '姓名',key: 'insurantName',width:100},
				{title: '性别',key: 'insurantGenderName',width:70},
                {title: '年龄',key: 'insurantAge',width:70},
                {title: '证件号码',slot: "insurantCertificateNumber",width:190},
                {title: '方案',key: 'insuranceSchemeName',width:460},
                {title: '是否高空',slot: 'isAerial',width:100},
				{title: '工种',key: 'jobTypeName',width:150},
				{title: '变更情况',key: 'changeType',width:100},
				{title: '保费',slot: 'insurantAmount',width:100},
				{title: '原姓名',key: 'refInsurantName',width:100},
				{title: '原身份证号',key: "refInsurantCertificateNumber",width:190},
				// {title: '是否高空',key: 'jobTypeName',width:150},
				{title: '原工种',key: 'refWorkTypeName',width:150},
                {title: '原方案',key: 'refInsurancePlanName',width:460},
			],
			addShow:false,
			canDownload:false,
			uuid:'',
			addForm:{},
			addFormRules:{
				count:[{required:true,message:'请填写正整数',trigger:'blur',pattern:/^[0-9]+$/}],
				workTypeName:{required:true,message:'请选择职业/工种',trigger:'change'},
				insurancePlanName:{required:true,message:'请选择计划',trigger:'change'},
				isAerial:{required:true,message:'请选择高空/非高空',trigger:'change'},
			},
			editShow:false,
			replaceShow:false,
			confirmShow:false,
			confirmForm:{},
			caseList:[],
			subList:[],
			correctUrl:'',
			confirmLoading:false,
			jobList:[],
			channel:'',
			isAerial:false, // 是否包含高空
			isNoAerial:false,// 是否包含非高空
			caseListAll:[],
			isReset:this.$route.query.reset||'', // reset=1重新投保
			orderNo:this.$route.query.orderNo||'',
			orderData:[], // 所有可被替换的人员
			selectedList:[], // 选中替换人员
			replaceList:[], // 确认替换人员
			orderDataConfirm:[], // 确认批量操作信息人员
			canTrue:false,
		}
	},
	computed: {
		canSub(){
			let list=this.addList.filter(item=>{
				return item.status!=0
			})
			return list.length>0
		},
		fiveRisk(){
			let fiveRisk=false
			this.addList.forEach(item=>{
				if(item.fiveRisk)fiveRisk=true
			})
			return fiveRisk
		}
	},
	created () {
		this.getJobList();
		this.getInfo();
	},
	mounted(){
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	methods:{
		// 下载模板
		downloadPd() {
			this.exportToExcel('/employerLiability/exportCorrect',{
				uuid:this.confirmForm.uuid,
				policyId:this.info.count||this.id
			})
		},
		chancel () {
			this.editShow = false
			this.selectedList = []
			this.$refs.selection.selectAll(false)
		},
		onSelectionChange (val) {
			this.selectedList = val
		},
		// 获取方案列表
		getCaseList () {
			// this.$axios.post('/employerLiability/getSchemeList',{
			// 	productCode:this.info.productCode
			// }).then(res=>{
			// 	this.caseListAll=res;
			// });
			// 现逻辑 针对可选方案
			if(this.addForm.workTypeCode&&this.addForm.isAerial){
				this.$axios.post('/employerLiability/queryUsablePlanList',{
					workTypeCode: this.addForm.workTypeCode,
					policyId: this.id,
					isAerial: this.addForm.isAerial
				}).then(res=>{
					this.caseListAll = res;
				});
			}
		},
		aerialChange (val) {
			this.$set(this.addForm,'insuranceSchemeCode',''); // 方案重置
			this.$set(this.addForm,'insurancePlanName','');
			// this.addForm.insurancePlanName = ''
			// this.addForm.jobTypeCode = ''
			// this.$forceUpdate()
			// console.log(this.addForm)
			this.getCaseList()
		},
		// 获取已存在保单中职业工种和对应保障计划
		getJobList() {
			this.$axios.post('/employerLiability/queryUsableWorkType',{
				policyId:this.id
			}).then(res=>{
				this.jobList=res;
			});
		},
		hideIdCard (str,frontLen=4,endLen=3) { 
			if(!str)return ''
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		/*获取订单信息*/
		async getInfo () {
			let obj = {policyId:this.id}
			if (this.isReset)obj={orderNo:this.orderNo}
			let res = await this.$axios.post('/employerLiability/getDetailInfo.json',obj)
			this.info=res;
			this.channel=res.source;
			if (!this.isReset) {
				res.list=res.list.filter(item=>{
					if(item.insuranceStatus==2||item.insuranceStatus==3){
						item.status=0;
					}
					return item.status==0
				})
			} 
			this.originalList=this.jsonCopy(res.list);
			if (this.isReset) {
				let plist = this.jsonCopy(res.list)
				plist.map(item=>{
					item.id=''
					return item
				})
				let alist = []
				let blist = []
				plist.forEach(item=>{
					if (item.status!=2&item.status!=5) {
						alist.push(item)
					} else {
						blist.push(item)
					}
				})
				this.addList = await this.$axios.post('/employerLiability/editEmployeeInformation?productCode='+this.info.productCode+'.json',alist)
				this.addList = this.addList.concat(blist)
			} else {
				// this.orderData=res.list;
				// let list = []
				// res.list.forEach(el=>{
				// 	if (this.channel=='QZG'&&el.status==0) list.push(el)
				// })
				// this.orderData = list
				this.orderData =res.list.filter(item=>{
					return this.channel=='QZG'&&item.status==0
				})
			}
			res.list.forEach(el=>{
				if (el.isAerial) this.isAerial=true
				else this.isNoAerial=true
			})
			// this.getCaseList()
		},
		checkPerson(insurantCertificateNumber) {
			let index=this.addList.findIndex(item=>{
				return item.status!=3&&item.status!=5&&item.insurantCertificateNumber==insurantCertificateNumber
			})
			if(index>-1){
				this.alert('身份证号与列表人员重复，请核对身份证号。')
				return false
			}else{
				return true
			}
		},
		// 添加
		add() {
			this.addShow=true;
			this.addForm={
				isAerial:''
			};
			this.$refs.addForm.resetFields();
			console.log(this.addForm)
		},
		batch() {
			this.$router.push('/company-group-employergs/edit-batch/'+this.id)
		},
		// 确定
		confirmAdd(){
			if (this.addForm.count==0) {
				this.alert('人数必须大于0')
				return
			}
			this.$refs.addForm.validate(valid=>{
				if(valid){
					this.addList.push({
						...this.addForm,
					});
					this.$nextTick(()=>{
						this.addShow= false
					})
					// this.getPremium({
					// 	...this.addForm,
					// 	policyId:this.id,
					// }).then(res=>{
					// 	this.addList.push({
					// 		...res,
					// 		remarks:'新增',
					// 		insuranceStatusName:'新增'
					// 	});
					// 	this.addShow=false;
					// })
				}
			})
		},
		// 确定修改
		confirmEdit(){
			let list = [...this.replaceList,...this.selectedList]
			this.replaceList = this.uniqueArray(list,'insurantCertificateNumber')
			this.$refs.selection.selectAll(false)
			this.$nextTick(()=>{
				this.editShow= false
			})
		},
		// 删除新增
		del1(index) {
			this.confirm('确定删除添加工种？',()=>{
				this.addList.splice(index,1)
			})
		},
		// 删除新增
		del2(index) {
			this.confirm('确定删除该人员？',()=>{
				this.replaceList.splice(index,1)
			})
		},
		// 价格格式化，最多2位小数
		numFormat(num){
			return Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
		},
		// 打开替换
		openRelace(row) {
			this.editShow=true;
		},
		// 提交
		sub() {
			this.confirm('确定提交信息？',()=>{
				this.$axios.post('/employerLiability/confirmAllEmployee.json',this.orderDataConfirm).then(res=>{
					this.replaceShow = false
					this.confirmForm=res;
					this.confirmShow=true
				});
			})
			
		},
		// 确认跳转
		confirmSub() {
			this.confirmLoading=true;
			this.$axios.post('/employerLiability/confirmAndCreateOrder.json',{
				correctUrl:this.correctUrlList.join(','),
				// correctUrl:this.correctUrl,
				vo:this.orderDataConfirm,
				productCode:this.info.productCode
			}).then(async res=>{
				this.confirmLoading=false;
				this.confirmShow=false
				// 回溯 停止录制
				await this.stopRecord({
					session_key:sessionStorage.track_session_key,
					policy_id:res
				});
				this.$nextTick(()=>{
					if(this.confirmForm.finalAmount>0){
						// 跳转支付
						window.location.replace(`/common.html#/new-pay?orderNo=${res}&productCode=${this.info.productCode}`)
					}else if(this.confirmForm.finalAmount==0){
						// 返回保单
						// this.$router.back();
						window.location.replace(`/common.html#/new-pay?orderNo=${res}&productCode=${this.info.productCode}`)
						// window.location.replace(`/haierProduct.html#/my/policy-detail/${this.id}`);
					}
				})
			});
		},
		// 高空选择工种
		jobChange(val,key) {
			this.$set(this[key],'workTypeName',val.label)
			this.$set(this[key],'workTypeCode',val.value)
			this.$set(this.addForm,'insuranceSchemeCode',''); // 方案重置
			this.$set(this.addForm,'insurancePlanName','');
			this.getCaseList()
		},
		// 下载模板
		async download() {
			if (this.replaceList.length==0&&this.addList.length==0) {
				this.alert('请先添加工种或被替换人员，再进行下载操作')
				return
			}
			let obj = {}
			this.caseListAll.forEach(el=>{
				obj[el.planName] = el.planCode
			})
			console.log(obj)
			this.addList.map((el)=>{
				el.insurancePlanCode = obj[el.insurancePlanName]
				el.count = Number(el.count)
			})
			this.replaceList.map((el)=>{
				el.insurancePlanCode = el.insuranceSchemeCode
				el.insurancePlanName = el.insuranceSchemeName
				el.workTypeName = el.jobTypeName
				el.workTypeCode = el.jobTypeCode
				if(el.isAerial) el.isAerial = 1
				else el.isAerial = 0
			})
			let res =  await this.$axios.post('/employerLiability/exportBatchCorrectTemplate.json',{
				replaceList:this.replaceList,
				addList:this.addList,
				policyId:this.$route.params.id
			})
			this.canDownload = true
			location.href = res
		},
		/*上传成功后获取数据*/
		uploadSuccessList (res) {
			if(res.code==10000000) {
				this.canTrue = false
				this.orderDataConfirm = res.data||[]
				this.orderDataConfirm.forEach(el=>{
					if (!el.pass) this.canTrue = true
				})
				this.replaceShow = true
			} else {
				this.alert(res.msg)
			}
		},
		// uploadSuccess (res) {
		// 	this.correctUrl=res.url
		// },
        /*上传成功后获取数据*/
		uploadSuccess (res) {
			// this.correctUrl=res.url
            if(this.correctUrlList.length<9) {
                this.correctUrlList.push(res.url)
            } else {
                this.alert('最多上传9张批改单！')
            }
            
		},
        del (index) {
            this.correctUrlList.splice(index, 1)
        },
		// json数组去重
		uniqueArray(array, key){
			let result = [array[0]];
			for(var i = 1; i < array.length; i++){
				var item = array[i];
				var repeat = false;
				for (var j = 0; j < result.length; j++) {
					if (item[key] == result[j][key]) {
						repeat = true;
						break;
					}
				}
				if (!repeat) {
					result.push(item);
				}
			}
			return result;
		}
	}
}
</script>
<style scoped lang="less">
.fixed-bottom{
	z-index: 99;
	position: fixed;
    padding: 10px;
	font-size: 14px;
	background: #fff;
	box-shadow: #eaeaea 0px 0px 10px;
	padding: 10px;
	bottom: 150px;
}
.mb0{
	margin-bottom: 0;
}
.edit-warning{
	font-size: 14px;
	color: red;
	margin-right: 20px;
}
.errorMsg{
	font-size: 14px;
	color: red;
	float: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/EditBatch.vue